'use client';

import { ConfigProvider, App as AntApp } from 'antd';
import { useAtomValue } from 'jotai';
import { selectedLanguageAtom } from '@/global/store/atoms';
import { emotionTheme, lightTheme } from '../../theme/theme';
import { ThemeProvider } from '@emotion/react';
import StyledComponentsRegistry from '@/global/lib/antd-registry';

export default function ClientProviders({ children }: { children: React.ReactNode }) {
  const lang = useAtomValue(selectedLanguageAtom);

  return (
    <StyledComponentsRegistry>
      <ConfigProvider theme={lightTheme} locale={undefined}>
        <AntApp
          message={{
            top: 83,
            duration: 4,
            maxCount: 1,
          }}
        >
          <ThemeProvider theme={emotionTheme}>
            <div lang={lang}>{children}</div>
          </ThemeProvider>
        </AntApp>
      </ConfigProvider>
    </StyledComponentsRegistry>
  );
}
